import { render } from "./feedbackResultModal.vue?vue&type=template&id=3216d89c"
import script from "./feedbackResultModal.vue?vue&type=script&lang=js"
export * from "./feedbackResultModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__